import { ButtonActions } from '../buttonActions'
import { MediaActions } from '../mediaActions'
import { ActionsProps } from './actions.types'

const Actions = ({
  allowMedias,
  disabledMediaActions,
  onOpenUploadMediaModal,
  loading,
  onReset,
  comment,
  onSubmit,
  mediaArray
}: ActionsProps) => {
  const showMediaActions = Array.isArray(allowMedias) && allowMedias.length > 0
  const isValidComment = Boolean((comment && comment.trim().length) || mediaArray?.length)

  return (
    <div className="_d-flex _align-items-center _justify-content-between _p-3" data-test="actions">
      {showMediaActions && (
        <MediaActions
          allowMedias={allowMedias}
          disabledActions={disabledMediaActions}
          onClick={onOpenUploadMediaModal}
        />
      )}

      <ButtonActions
        disabledActions={loading}
        disabledSubmit={loading || !isValidComment}
        onReset={onReset}
        onSubmit={onSubmit}
      />
    </div>
  )
}

export default Actions
